import {
  Component,
  HostListener,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { DashboardService } from "../../../features/dashboard/services/dashboard.service";
import { DashboardListItem } from "../../../models/dashboard.model";
import { UserProfile } from "../../../models/profile.model";
@Component({
  selector: "app-tile",
  imports: [CommonModule],
  templateUrl: "./tile.component.html",
  styleUrl: "./tile.component.scss",
})
export class TileComponent {
  @Input({ required: true }) tileInfo!: DashboardListItem;
  @Input() backgroundColor: string = "#FFFFFF";
  @Output() favoriteUpdated = new EventEmitter<void>();
  isMobileWidth: boolean = false;
  isHovered: boolean = false;
  favorite: string = "";
  constructor(
    private router: Router,
    private dashboardService: DashboardService
  ) {}
  ngOnInit() {
    const profile = localStorage.getItem("profile");
    if (profile) {
      const profileData = JSON.parse(profile);
      this.favorite = profileData.favorite || "";
    } else {
      this.favorite = "";
    }
  }

  onTileClick(cardInfo: DashboardListItem) {
    if (cardInfo.link) {
      if (cardInfo.name.toLowerCase() === "upload files") {
        this.router.navigate([cardInfo.link], {
          queryParams: { upload: true },
        });
      } else if (cardInfo.id === 6) {
        this.router.navigate([cardInfo.link], {
          queryParams: { type: cardInfo.cardKey },
        });
      } else {
        this.router.navigate([cardInfo.link]);
      }
    }
  }

  onFavIconClick(event: Event, favorite: string) {
    event.stopPropagation(); // Prevent the tile click event from firing
    const userProfile = JSON.parse(localStorage.getItem("profile") as string);

    if (userProfile.favorite) {
      // If favorite already exists, remove it
      if (userProfile.favorite.includes(favorite)) {
        userProfile.favorite = userProfile.favorite
          .split(",")
          .filter((fav: string) => fav !== favorite)
          .join(",");
      } else {
        // If favorite doesn't exist, append it with a comma
        userProfile.favorite = userProfile.favorite + "," + favorite;
      }
    } else {
      // If no favorites exist, create new one
      userProfile.favorite = favorite;
    }

    // Remove isUpdated flag before sending to service
    const { isUpdated, ...profileWithoutUpdateFlag } = userProfile;

    this.dashboardService
      .updateUserFavorite(profileWithoutUpdateFlag)
      .subscribe((res: UserProfile) => {
        const profileWithUpdateFlag = { ...res, isUpdated: true };
        localStorage.setItem("profile", JSON.stringify(profileWithUpdateFlag));
        this.favoriteUpdated.emit(); // Emit event to refresh dashboard
      });
  }
}
